import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { List, ListItem, ListItemText } from '@material-ui/core';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';

import Texto from '../../commons/Texto';
import Modal from '../../commons/Modal';
import Combo from '../../commons/Combo';
import Boton from '../../commons/Boton';
import MaterialCommunityIcons from '../../commons/Icons/MaterialCommunityIcons';
import Ubigueo from '../../components/ubigueo/Ubigueo';
import { confirmacion } from '../../commons/Mensajes';

import {
  closeModal,
  postClienteAction,
} from '../../redux/actions/cliente.action';

import SaveIcon from '@material-ui/icons/Save';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { generateUUID } from '../../commons/Utilitarios';

const ClienteItem = ({
  selected,
  processing,
  errors,
  tipoDocumentoIdentidad,
  closeModal,
  postClienteAction,
}) => {
  const [cliente, setCliente] = useState(selected);
  const [openUbigueo, setOpenUbigueo] = useState(false);
  const [phones, setPhones] = useState(
    selected.lt
      ? selected.lt.map((x) => ({ id: generateUUID(), tl: x, edit: false }))
      : []
  );
  const [emails, setEmails] = useState(
    selected.lc
      ? selected.lc.map((x) => ({ id: generateUUID(), em: x, edit: false }))
      : []
  );

  useEffect(() => {
    let searchTipo = tipoDocumentoIdentidad.find((s) => s.de === selected.dt);
    if (searchTipo) {
      handleChange({ name: 'td', value: searchTipo.dt });
    }
  }, []);

  const handleChange = (item) => {
    const { name, value } = item;
    setCliente((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <Modal
        title={`${cliente.cl ? 'Actualizar' : 'Nuevo'} cliente`}
        processing={processing}
        onActions={() => (
          <Boton
            className="op-grabar"
            disabled={processing}
            icon={() => <SaveIcon />}
            tabIndex={21}
            onClick={() =>
              confirmacion(
                '¿Desea guardar?',
                `${cliente.cl ? 'Actualizar' : 'Un nuevo'} cliente`
              )
                .then(() =>
                  postClienteAction({
                    ...cliente,
                    lt: [...new Set(phones.map((x) => x.tl.trim()))],
                    lc: [...new Set(emails.map((x) => x.em.trim()))],
                  })
                )
                .catch(() => {})
            }
          >
            Guardar
          </Boton>
        )}
        onClose={() => closeModal()}
      >
        <Combo
          name="td"
          label="Tipo documento"
          value={cliente.td}
          tabIndex={10}
          size={2}
          data={tipoDocumentoIdentidad.map((i) => ({
            value: i.dt,
            label: i.de,
          }))}
          error={errors.td}
          onChange={handleChange}
        />
        <Texto
          name="nd"
          value={cliente.nd}
          label="N&uacute;mero de documento"
          tabIndex={11}
          size={2}
          error={errors.nd}
          onChange={handleChange}
          restrict={'int'}
        />
        <Texto
          name="dn"
          value={cliente.dn}
          label="Nombres completos"
          tabIndex={12}
          size={2}
          error={errors.dn}
          onChange={handleChange}
        />
        <Texto
          name="tf"
          value={cliente.tf}
          label="Tel&eacute;fono principal"
          tabIndex={13}
          size={2}
          enabledPaste={true}
          error={errors.tf}
          onChange={handleChange}
        />
        <Texto
          name="ce"
          value={cliente.ce}
          label="Correo electr&oacute;nico principal"
          tabIndex={14}
          size={2}
          enabledPaste={true}
          error={errors.ce}
          onChange={handleChange}
        />
        <Texto
          name="du"
          value={cliente.du}
          label="Ubigueo"
          size={2}
          tabIndex={15}
          error={errors.du}
          onChange={() => {}}
          icon={() => <LocationOnIcon onClick={() => setOpenUbigueo(true)} />}
        />
        <Texto
          name="di"
          value={cliente.di}
          label="Direcci&oacute;n"
          tabIndex={16}
          enabledPaste={true}
          error={errors.di}
          onChange={handleChange}
        />
        <div className="op-form-group op-col-2">
          <div
            onClick={() =>
              setPhones([...phones, { id: generateUUID(), tl: '', edit: true }])
            }
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <span>Tel&eacute;fonos de contacto</span>
            <MaterialCommunityIcons name="plus" />
          </div>
          <List>
            {phones.map((p) => (
              <ListItem key={p.id}>
                <PhoneIcon
                  onClick={() =>
                    setPhones(
                      phones.map((x) =>
                        x.id === p.id ? { ...x, edit: !p.edit } : x
                      )
                    )
                  }
                  style={{ cursor: 'pointer' }}
                />
                {p.edit ? (
                  <input
                    type="text"
                    value={p.tl}
                    onChange={(e) =>
                      setPhones(
                        phones.map((x) =>
                          x.id === p.id ? { ...x, tl: e.target.value } : x
                        )
                      )
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setPhones(
                          phones.map((x) =>
                            x.id === p.id ? { ...x, edit: false } : x
                          )
                        );
                      }
                    }}
                    onBlur={() => {
                      setPhones(
                        phones.map((x) =>
                          x.id === p.id ? { ...x, edit: false } : x
                        )
                      );
                    }}
                  />
                ) : (
                  <>
                    <ListItemText
                      onClick={() =>
                        setPhones(
                          phones.map((x) =>
                            x.id === p.id ? { ...x, edit: true } : x
                          )
                        )
                      }
                    >
                      {p.tl}
                    </ListItemText>
                    <CancelPresentationIcon
                      color="secondary"
                      onClick={() =>
                        setPhones(phones.filter((x) => x.id !== p.id))
                      }
                      style={{ cursor: 'pointer' }}
                    />
                  </>
                )}
              </ListItem>
            ))}
          </List>
        </div>
        <div className="op-form-group op-col-2">
          <div
            onClick={() =>
              setEmails([...emails, { id: generateUUID(), em: '', edit: true }])
            }
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <span>Correos de contacto</span>
            <MaterialCommunityIcons name="plus" />
          </div>
          <List>
            {emails.map((p) => (
              <ListItem key={p.id}>
                <EmailIcon
                  onClick={() =>
                    setEmails(
                      emails.map((x) =>
                        x.id === p.id ? { ...x, edit: !p.edit } : x
                      )
                    )
                  }
                  style={{ cursor: 'pointer' }}
                />
                {p.edit ? (
                  <input
                    type="text"
                    value={p.tl}
                    onChange={(e) =>
                      setEmails(
                        emails.map((x) =>
                          x.id === p.id ? { ...x, em: e.target.value } : x
                        )
                      )
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        setEmails(
                          emails.map((x) =>
                            x.id === p.id ? { ...x, edit: false } : x
                          )
                        );
                      }
                    }}
                    onBlur={() => {
                      setEmails(
                        emails.map((x) =>
                          x.id === p.id ? { ...x, edit: false } : x
                        )
                      );
                    }}
                  />
                ) : (
                  <>
                    <ListItemText
                      onClick={() =>
                        setEmails(
                          emails.map((x) =>
                            x.id === p.id ? { ...x, edit: true } : x
                          )
                        )
                      }
                    >
                      {p.em}
                    </ListItemText>
                    <CancelPresentationIcon
                      color="secondary"
                      onClick={() =>
                        setEmails(emails.filter((x) => x.id !== p.id))
                      }
                      style={{ cursor: 'pointer' }}
                    />
                  </>
                )}
              </ListItem>
            ))}
          </List>
        </div>
      </Modal>
      {openUbigueo && (
        <Ubigueo
          onClose={() => setOpenUbigueo(false)}
          onSend={(ubigueo) => {
            handleChange({ name: 'ubl', value: ubigueo.ub });
            handleChange({ name: 'du', value: ubigueo.di });
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    selected: state.cliente.selected,
    processing: state.cliente.processing,
    errors: state.cliente.errors,
    tipoDocumentoIdentidad: state.detalle.tipoDocumentoIdentidad,
  };
};

export default connect(mapStateToProps, { closeModal, postClienteAction })(
  ClienteItem
);
